import React, { useEffect, useState } from "react";
import { Container, Row, Col, Nav, } from "react-bootstrap";
import {
  FaGooglePlay,
  FaApple,
} from "react-icons/fa";
import logo from "../../../assets/images/logo1.svg";
import { Link, useNavigate } from "react-router-dom";
import {
  getAuthDetails,
  playStoreUrl,
  socialLinks,
} from "../../../constants/helpers";
import Authentication from "../Authentication/Authentication";
import UserSelectionModal from "../../../components/UserSelectionModal";
import VisitorCounter from "../../../components/VisitorCounter";
import { useGetBranchesQuery } from "../../../redux/api/Branches/BranchesApi";
import AppComingSoonModal from "../../../components/AppComingSoonModal";
import "./Footer.css";

function Footer() {
  const Navigate = useNavigate();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showUserModel, setShowUserModel] = useState(false);
  const { isAuthenticated } = getAuthDetails();
  const [navigationPath, setNavigationPath] = useState("");
  const [branchOptions, setBranchOptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const { data: branchesData } = useGetBranchesQuery({
    page: "",
  });

  useEffect(() => {
    if (branchesData && branchesData.success && branchesData.data) {
      setBranchOptions(branchesData.data);
    }
  }, [branchesData]);

  const openModal = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleTestimonialClick = () => {
    Navigate("/");

    setTimeout(() => {
      const testimonialsSection = document.getElementById("testimonials");
      if (testimonialsSection) {
        testimonialsSection.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 500);
  };

  const handleUserSelect = (user) => {
    setShowUserModel(false);
    Navigate(navigationPath, { state: { user } });
  };

  const handleIssueClick = () => {
    Navigate("/contact-us", {
      state: {
        activeForm: "issue",
        scrollToForm: true,
      },
    });
  };

  const handleNavigation = (path) => {
    const userSelectionRoutes = ["/bookings", "/prescription", "/reports"];

    if (userSelectionRoutes.includes(path)) {
      if (!isAuthenticated) {
        setShowAuthModal(true);
      } else {
        setNavigationPath(path);
        setShowUserModel(true);
      }
    } else {
      Navigate(path);
    }
  };



  return (
    <footer className="footer-redesign mt-5">
      <Container>
        {/* Top Link Section - 5 Columns */}
        <Row className="footer-top-links py-5 px-lg-0 px-3 justify-content-between">
          <Col lg={2} md={4} sm={6} xs={12} className="mb-4 mb-lg-0">
            <h4 className="footer-link-heading mb-4">Quick Links</h4>
            <Nav className="flex-column">
              <Nav.Link
                onClick={() => Navigate("/about-us")}
                className="footer-link"
              >
                About us
              </Nav.Link>
              <Nav.Link
                onClick={() => Navigate("all-Individual-tests")}
                className="footer-link"
              >
                Individual Test
              </Nav.Link>
              <Nav.Link
                onClick={() => Navigate("/all-package-tests")}
                className="footer-link"
              >
                Package Test
              </Nav.Link>
              <Nav.Link
                onClick={handleTestimonialClick}
                className="footer-link"
              >
                Testimonials
              </Nav.Link>
            </Nav>
          </Col>

          <Col lg={2} md={4} sm={6} xs={12} className="mb-4 mb-lg-0">
            <h4 className="footer-link-heading mb-4">Patient Support</h4>
            <Nav className="flex-column">
              <Nav.Link
                onClick={() => Navigate("/contact-us")}
                className="footer-link"
              >
                Contact us
              </Nav.Link>
              <Nav.Link onClick={handleIssueClick} className="footer-link">
                Raise Complaint
              </Nav.Link>
              <Nav.Link
                onClick={() => handleNavigation("/prescription")}
                className="footer-link"
              >
                Upload Prescription
              </Nav.Link>
              <Nav.Link
                onClick={() => handleNavigation("/reports")}
                className="footer-link"
              >
                View reports
              </Nav.Link>
            </Nav>
          </Col>

          <Col lg={2} md={4} sm={6} xs={12} className="mb-4 mb-lg-0">
            <h4 className="footer-link-heading mb-4">Company</h4>
            <Nav className="flex-column">
              <Nav.Link
                onClick={() => Navigate("/careers")}
                className="footer-link"
              >
                Career
              </Nav.Link>
              <Nav.Link
                onClick={() => Navigate("/gallery")}
                className="footer-link"
              >
                Gallery
              </Nav.Link>
              <Nav.Link
                onClick={() => Navigate("/blogs")}
                className="footer-link"
              >
                Blog
              </Nav.Link>
              <Nav.Link
                onClick={() => Navigate("/corporate-wellness")}
                className="footer-link"
              >
                Corporate Wellness
              </Nav.Link>
            </Nav>
          </Col>

          <Col lg={2} md={4} sm={6} xs={12} className="mb-4 mb-lg-0">
            <h4 className="footer-link-heading mb-4">Our Branches</h4>
            <Nav className="flex-column">
              {branchOptions.slice(0, 4).map((branch) => (
                <Nav.Link
                  key={branch._id}
                  onClick={() => {
                    const branchSlug = branch.branchName
                      .toLowerCase()
                      .trim()
                      .replace(/\s+/g, "-");
                    Navigate(`/branch/${branchSlug}`, {
                      state: { id: branch._id },
                    });
                  }}
                  className="footer-link"
                >
                  {branch.branchName}
                </Nav.Link>
              ))}
            </Nav>
          </Col>

          <Col lg={2} md={4} sm={6} xs={12} className="mb-4 mb-lg-0">
            <h4 className="footer-link-heading mb-4">Follow Us</h4>
            <Nav className="flex-column">
              {socialLinks.map((link, index) => {
                const Icon = link.icon;
                return (
                  <Nav.Link
                    key={index}
                    href={link.url}
                    target="_blank"
                    className="footer-link d-flex align-items-center gap-2"
                  >
                    <Icon size={16} />
                    {link.name}
                  </Nav.Link>
                );
              })}
            </Nav>
          </Col>
        </Row>

        <hr className="footer-divider" />

        {/* Bottom Split Section */}
        <Row className="mobile-footer-stack">
          {/* Main Branding Section */}
          <Col lg={7} md={12} className="mb-5 mb-lg-0 branding-column">
            <div className="d-flex flex-column">
              {/* Logo Section - Top on mobile, Bottom on desktop */}
              <div className="footer-logo-box order-1 order-lg-2 mt-lg-5 mb-4 mb-lg-0">
                <img
                  src={logo}
                  alt="iDiag"
                  className="img-fluid footer-hero-logo"
                  style={{ maxWidth: "450px", aspectRatio: "450 / 100", objectFit: "contain" }}
                  width="450"
                  height="100"
                  loading="lazy"
                />
              </div>
              {/* Header and Description */}
              <Row className="mb-4 order-2 order-lg-1">
                <Col md={3} xs={12}>
                  <h2 className="text-white fw-bold h4 mb-3">Who we are</h2>
                </Col>
                <Col md={9} xs={12}>
                  <p
                    className="text-white-50 small pe-lg-4 mb-0"
                    style={{ lineHeight: "1.6" }}
                  >
                    iDiag is committed to providing
                    accurate, reliable, and hassle-free lab testing services.
                    With cutting-edge technology and expert healthcare
                    professionals, we ensure high-quality diagnostics for your
                    well-being.
                  </p>
                </Col>
              </Row>
            </div>
          </Col>

          {/* Vertical Spacer/Divider for Desktop */}
          <Col lg={1} className="d-none d-lg-flex justify-content-center">
            <div className="vr bg-white opacity-25 h-100"></div>
          </Col>

          {/* App & Legal Section */}
          <Col lg={4} md={12}>
            <div className="ps-lg-3">
              <h5 className="text-white fw-bold mb-3">
                Download Our Mobile App
              </h5>
              <p className="text-white-50 small mb-4">
                Get access to exclusive offers and book tests instantly with our
                mobile application
              </p>

              <Row className="mb-5 g-2 app-buttons-row">
                <Col xs={12} sm={6}>
                  <Link
                    to={playStoreUrl}
                    target="_blank"
                    className="btn-app-download google-btn-dark text-decoration-none w-100"
                  >
                    <FaGooglePlay size={20} className="me-2 text-white" />
                    <div className="btn-label-box">
                      <span className="btn-top-text">GET IT ON</span>
                      <span className="btn-main-text text-white">
                        Google Play
                      </span>
                    </div>
                  </Link>
                </Col>
                <Col xs={12} sm={6}>
                  <Link
                    to="#"
                    onClick={openModal}
                    className="btn-app-download apple-btn-dark w-100"
                  >
                    <FaApple size={24} className="me-2" />
                    <div className="btn-label-box">
                      <span className="btn-top-text">Download on the</span>
                      <span className="btn-main-text">App Store</span>
                    </div>
                  </Link>
                </Col>
              </Row>

              <Nav className="flex-column gap-2 mb-4">
                <Nav.Link
                  onClick={() => handleNavigation("/terms-and-conditions")}
                  className="footer-small-link p-0"
                >
                  Terms&Conditions
                </Nav.Link>
                <Nav.Link
                  onClick={() => handleNavigation("/privacy-policy")}
                  className="footer-small-link p-0"
                >
                  Privacy Policy
                </Nav.Link>
                <Nav.Link
                  onClick={() => handleNavigation("/cancellation-and-refund")}
                  className="footer-small-link p-0"
                >
                  Cancellation and refund
                </Nav.Link>
              </Nav>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Footer Copyright Bar */}
      <div className="footer-copyright-bar py-4">
        <Container>
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <p className="copyright-text mb-0">
              © {new Date().getFullYear()} iDiag Pvt Ltd. All rights
              reserved.
            </p>
            <p className="developed-by-text mb-0">
              Developed by{" "}
              <a
                href="https://www.idealcorp.in/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#c6d630" }}
              >
                Ideal Corporate Services
              </a>
            </p>
            <div className="visitor-footer-wrapper mt-2 mt-md-0">
              <VisitorCounter />
            </div>
          </div>
        </Container>
      </div>



      {/* Authentication Modal */}
      {showAuthModal && (
        <Authentication onClose={() => setShowAuthModal(false)} />
      )}

      {/* User Selection Modal */}
      <UserSelectionModal
        show={showUserModel}
        onHide={() => setShowUserModel(false)}
        onUserSelect={handleUserSelect}
      />
      <AppComingSoonModal
        show={showModal}
        onHide={closeModal}
        title="Coming Soon!"
        body="This app is not yet available in the stores. Please check back later."
        buttonText="Got it"
        buttonVariant="primary"
      />
    </footer>
  );
}

export default Footer;
